// PremiumScheduleCard.js (Corrected)
import React from 'react';
import Battery from './Battery';
import { Grid } from "@material-ui/core";

// Helper to format numbers as currency
const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(amount);
};

const PremiumScheduleCard = ({ years, youPay, bankPays }) => {
    return (
            <Grid item xs={12} sm={6} md={6} justify="center" alignItems="center">
                <svg width="300" height="150" viewBox="80 0 300 270" fontFamily="Arial, Helvetica, sans-serif">
                    <defs>
                        <filter id="text-background" x="0" y="0" width="1" height="1">
                            <feFlood flood-color="rgb(27, 38, 59)" />
                            <feComposite in="SourceGraphic" operator="over" />
                        </filter>
                    </defs>
                    {/* Section Title */}
                    <text x="70%" y="55" fontSize="20" fill="#34C1F8" textAnchor="middle" filter="url(#text-background)">
                        Years {years}
                    </text>

                    {/* Dotted container box */}
                    <rect x="5" y="50" width="410" height="220" rx="20" fill="none" stroke="#3063A1" strokeWidth="2" strokeDasharray="6 6" />

                    {/* Left side: "You Pay" */}
                    <g transform="translate(30, 50)">
                        <g transform="translate(0, 55)">
                            <Battery bars={youPay.bars} activeColor="#FF2E8A" />
                        </g>
                        <text x="75" y="90" fontSize="20" fill="#FF2E8A">You Pay</text>
                        <text x="75" y="120" fontSize="22" fontWeight="bold" fill="#FFFFFF">{formatCurrency(youPay.amount)}</text>
                        <text x="75" y="140" fontSize="18" fill="#B0B0B0">/ year</text>
                    </g>

                    {/* Right side: "Bank Pays" */}
                    <g transform="translate(230, 50)">
                        <g transform="translate(0, 55)">
                            <Battery bars={bankPays.bars} activeColor="#FFB800" />
                        </g>
                        <text x="75" y="90" fontSize="20" fill="#FFB800">Bank Pays</text>
                        <text x="75" y="120" fontSize="22" fontWeight="bold" fill="#FFFFFF">{formatCurrency(bankPays.amount)}</text>
                        <text x="75" y="140" fontSize="18" fill="#B0B0B0">/ year</text>
                    </g>
                </svg>
            </Grid>
    );
};

export default PremiumScheduleCard;